import styled from 'styled-components';
import { Retry } from '@components/common';
import Table from '@components/common/Table';

export const StyledTable = styled(Table)`
.BaseTable__table .BaseTable__row {
  .BaseTable__row-cell {
    padding: 0px 5px;
    border-bottom: 1px solid rgb(221, 221, 221) !important;
    overflow: visible!important;
  }
}

.BaseTable__table-frozen-left .BaseTable__header-cell:first-child,
.BaseTable__table-frozen-left .BaseTable__row-cell:first-child {
  padding-left: 7.5px;
}
`;

export const StyledTableWrapper = styled.div`
  width: auto;
  min-height: auto;
  flex: 1;
  margin: 0px 20px 20px 20px;
`;

export const RealtimeTileWrapper = styled.div`
  padding: 20px 0px;
  height: 100%;
`;

export const LoadingWrapper = styled(Retry)`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

export const ScopeWrapper = styled.span`
  width: 100%;
  padding-right: 7.5px;
`;

export const HoverDiv = styled.div`
  width: 100%;
  .handle {
    visibility: hidden;
  }

  &:hover .handle {
    visibility: visible;
  }
`;

export const StyledRowHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  width: 100%;

  .row-header-text {
    width: 100%;
    color: #4f4f4f;
    font-size: 16px;
    padding: 5px 0;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .row-header-chart-switch {
    .line{
      path{
        stroke: #333;
      }
    }
    .line.active {
      background-color: #e9f3fd;
      border: none;
      path{
        stroke: #096dd9;
      }
    }
    .bar{
      color: #333;
    }
    .bar.active {
      color: #096dd9;
      background-color: #e9f3fd;
      border: none;
    }
  }
`;

export const StyledColumnHeader = styled.div`
  display: flex;
  flex-direction: column;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
`;

export const StyledColumnHeaderText = styled.span`
  color: #000;
  font-size: 18px;
  padding-bottom: 7px;
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-right: 40px;
  padding-left:5px;
`;

export const StyledSortTag = styled.span`
  position: relative;
  border-left: 5px solid ${props => props.color};
  border-radius: 0px;
  color: #333;
  display: inline-block;
  height: auto;
  margin-right: 8px;
  padding: ${props => (props.active ? '0 20px 0 8px' : '0 0 0 8px')};
  font-size: 12px;
  line-height: 20px;
  white-space: nowrap;
  background: ${props => (props.active ? `${props.color}50` : 'none')};
  cursor: pointer;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
  i {
    padding: 0px 5px;
  }
  &.asc.active:after {
    content: "▲";
    position: absolute;
    font-size: 7px;
    margin: -4px 7px;
  }
  &.desc.active:after {
    content: "▼";
    position: absolute;
    font-size: 7px;
    margin: 2px 7px;
  }
`;

export const StyledSortLoader = styled.span`
  color: #333;
  .ant-spin-spinning{
    padding-bottom: 5px;
  }
`;

export const StyledSortContainer = styled.div`
  width: 100%;
  padding: 10px;
  background-color: #f6f6f6;
`;

export const StyledColumnDimensionHeader = styled.div`
   width:100%;
   padding-right: 5px;
  .column-text {
    color: #000;
    font-size: 18px;
    padding-bottom: 7px;
    cursor: pointer;
    overflow: hidden;
    text-overflow: ellipsis;
    padding-right: 5px;
    padding-left:5px;
    white-space: nowrap;
  }
  .column-info {
    width: 100%;
    padding: 4px 10px;
    background-color: #f6f6f6;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
`;
